module.exports = __webpack_public_path__ + "img/ps-16.5c224fc7.jpg";